export default "__VITE_ASSET__Dkvu3C_C__"